import {
	Box,
	Heading,
	HStack,
	Link,
	SimpleGrid,
	Text,
	VStack
} from "@chakra-ui/react";
import FullScreenSection from "./FullScreenSection";
import DownloadApp from "./DownloadApp";
import Disclosurre from "./disclosurre";

export default function Community() {
	return (
    <VStack spacing={0} width="100%">
		<FullScreenSection
			justifyContent="center"
			alignItems="center"
			isDarkBackground={false}
			backgroundColor="gray.50"
			py={100}
		>
			<VStack spacing={10} maxW="1200px" width="100%">
				<VStack spacing={4} textAlign="center" maxW="900px">
					<Heading fontSize={{ base: "2.2rem", md: "3rem" }} fontWeight="bold">
						Refer and Earn
					</Heading>
					<Text fontSize="1.2rem" color="gray.600" lineHeight="1.8">
						Invite your friends to join Swift Credit and you'll both get $100 each when they sign up, 
						and borrow $2500 or more.
					</Text>
				</VStack>

				<Box width="100%">
					<VStack spacing={6} align="stretch">
						<Heading fontSize="1.6rem" textAlign="center">
							How it works
						</Heading>
						<SimpleGrid columns={{ base: 1, md: 3 }} spacing={8} width="100%">
							<Box bg="white" borderRadius="xl" boxShadow="lg" p={6} border="1px solid" borderColor="gray.200">
								<HStack spacing={3} mb={3}>
									<Box bg="blue.50" color="blue.600" px={3} py={1} borderRadius="full" fontWeight="bold">
										Join
									</Box>
								</HStack>
								<Text color="gray.600" lineHeight="1.7">
									Create your Swift Credit account, get your unique referral link and share it with your friends and family.
								</Text>
							</Box>

							<Box bg="white" borderRadius="xl" boxShadow="lg" p={6} border="1px solid" borderColor="gray.200">
								<HStack spacing={3} mb={3}>
									<Box bg="purple.50" color="purple.600" px={3} py={1} borderRadius="full" fontWeight="bold">
										Refer
									</Box>
								</HStack>
								<Text color="gray.600" lineHeight="1.7">
									Your friend joins Swift Credit using your referral code and gets approved for a loan.
								</Text>
							</Box>

							<Box bg="white" borderRadius="xl" boxShadow="lg" p={6} border="1px solid" borderColor="gray.200">
								<HStack spacing={3} mb={3}>
									<Box bg="green.50" color="green.600" px={3} py={1} borderRadius="full" fontWeight="bold">
										Earn
									</Box>
								</HStack>
								<Text color="gray.600" lineHeight="1.7">
									When your friend gets a loan of $2500 or more, you both receive $100 each.
								</Text>
							</Box>
						</SimpleGrid>
					</VStack>
				</Box>

				<Link href="/referral-terms" color="blue.600" fontWeight="semibold">
					*Terms and conditions apply
				</Link>
			</VStack>
     
        </FullScreenSection>
		<Disclosurre />
     
    </VStack>
	);
}
